module.exports = __webpack_public_path__ + "img/qash.1baba72a.svg";